import React, { useState, useEffect } from "react";
import Layout from "../Common/Layout";
import LabourInbound from "./LabourInbound.jsx";
import LabourOutbound from "./LabourOutbound.jsx";
import { useLocation } from "react-router-dom";

const Labour = () => {
  const location = useLocation();
  const [type, setType] = useState("");

  useEffect(() => {
    if (location.state?.type) {
      setType(location.state.type);
    }
  }, [location.state]);

  return (
    <>
      <Layout>
        <div
          className="container d-flex justify-content-center align-items-center"
          style={{ minHeight: "10vh", width: "30rem" }}
        >
          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">-- Select Type --</option>
            <option value="inbound">Inbound</option>
            <option value="outbound">Outbound</option>
          </select>
        </div>

        {/* Render Selected Component */}
        {type === "inbound" && <LabourInbound />}
        {type === "outbound" && <LabourOutbound />}
      </Layout>
    </>
  );
};

export default Labour;
